import React, { startTransition, useEffect, useState } from 'react';
import baseURL from '../url';
import './NumerosRifas.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import { useParams } from "react-router-dom";
import Swal from 'sweetalert2';

Modal.setAppElement('#root'); // Accessibility

// Icon WhatsApp SVG (ou ka ranplase pa yon imaj si ou vle)
function WhatsappIcon() {
  return (
    <svg
      width="24" height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: '8px' }}
    >
      <path fill="#25D366" d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM17.4023 15.1764L16.5157 15.8634C16.3493 16.013 16.1391 16.0689 15.9403 16.0221C15.4445 15.8914 13.623 14.912 12.6778 13.8677C11.7327 12.8233 11.2727 11.8215 11.1477 11.3263C11.1009 11.1276 11.1576 10.9173 11.3073 10.7509L11.9943 9.86429C12.0723 9.77919 12.1223 9.67269 12.1384 9.55906C12.2644 8.75328 12.4824 8.02829 12.7866 7.40164C12.8841 7.19131 13.1465 7.11652 13.343 7.25019L14.953 8.37167C15.0957 8.46702 15.1842 8.63811 15.1745 8.82534C15.1688 8.92923 15.1504 9.03175 15.1212 9.12844C15.0507 9.3577 14.967 9.62925 14.9 9.87313C14.8681 10.0051 14.8451 10.1407 14.8315 10.2779C14.805 10.5578 14.8723 10.8489 15.0161 11.0781L15.9859 12.4383C16.0442 12.5302 16.051 12.6385 16.0041 12.7366C15.6835 13.4197 15.297 14.0142 14.8586 14.5144C14.7385 14.6555 14.5424 14.7333 14.3374 14.7281C14.0941 14.7217 13.8507 14.6785 13.6201 14.6L12.7954 14.2267C12.6836 14.1756 12.5397 14.1868 12.4364 14.2526L11.8911 14.6018C11.7887 14.6696 11.6838 14.7454 11.5914 14.8295L10.8829 15.4775C10.7777 15.5762 10.5985 15.5754 10.4994 15.4762L9.99269 14.9695C9.88765 14.8644 9.88765 14.688 9.99269 14.5829L10.6272 13.9484C10.6961 13.8795 10.7678 13.816 10.8418 13.7582C11.2136 13.4827 11.6303 13.3024 12.0747 13.2346C12.2636 13.205 12.4326 13.1276 12.5606 13.0114L13.095 12.5454C13.2608 12.381 13.299 12.1344 13.1826 11.9441C13.1395 11.8632 13.076 11.7997 13.0071 11.7308L11.4876 10.2113C11.3826 10.1063 11.3826 9.93 11.4876 9.82497L12.0561 9.2565C12.1876 9.12501 12.3844 9.10258 12.5329 9.20915L14.042 10.4746C14.3163 10.7086 14.5524 11.0157 14.7311 11.3741C14.8938 11.6922 14.9124 12.0561 14.782 12.3795C14.7395 12.5121 14.6483 12.6157 14.5322 12.6755L13.2831 13.2598C13.2094 13.2973 13.1316 13.3172 13.0543 13.3196L12.0721 13.3398L12.0721 13.3398Z"/>
    </svg>
  )
}

export default function NumerosRifas() {
  const [numeros, setNumeros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [contactos, setContactos] = useState({});
  const [name, setName] = useState('');
  const [telefono, setTelefono] = useState('');
  const [identificacion, setIdentificacion] = useState('');
  const [direccion, setDireccion] = useState('');
  const { idRifa } = useParams();
  const [rifa, setRifa] = useState(null);
  const [numerosSeleccionados, setNumerosSeleccionados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  useEffect(() => {
    cargarNumeros();
    cargarContacto();
    cargarRifas();
  }, [idRifa]);

  const cargarNumeros = () => {
    setLoading(true);
    fetch(`${baseURL}/numeroGet.php`)
      .then(res => res.json())
      .then(data => {
        const filtrados = data.numeros.filter(n => n.idRifa === parseInt(idRifa));
        setNumeros(filtrados);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error al cargar números:', err);
        setLoading(false);
      });
  };

  const cargarContacto = () => {
    fetch(`${baseURL}/contactoGet.php`)
      .then(res => res.json())
      .then(data => {
        setContactos(data.contacto.reverse()[0] || {});
      })
      .catch(err => console.error('Error al cargar contactos:', err));
  };

  const cargarRifas = () => {
    fetch(`${baseURL}/rifaGet.php`)
      .then(res => res.json())
      .then(data => {
        const rifaActual = data.rifas.find(r => r.idRifa === parseInt(idRifa));
        setRifa(rifaActual);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error al cargar rifas:', err);
        setLoading(false);
      });
  };

  const generarNumero = () => {
    if (rifa?.estado === 'finalizada') {
      Swal.fire('Rifa Finalizada', 'No se pueden generar números porque la rifa ha finalizado.', 'info');
      return;
    }
    const disponibles = numeros.filter(n => n.estado === 'disponible');
    if (disponibles.length === 0) {
      Swal.fire('Error', 'No hay números disponibles para seleccionar.', 'error');
      return;
    }
    const aleatorio = disponibles[Math.floor(Math.random() * disponibles.length)];
    if (!numerosSeleccionados.some(n => n.idNumero === aleatorio.idNumero)) {
      setNumerosSeleccionados([...numerosSeleccionados, aleatorio]);
    }
  };

  const handleNumeroClick = (numero) => {
    if (numerosSeleccionados.some(n => n.idNumero === numero.idNumero)) {
      setNumerosSeleccionados(numerosSeleccionados.filter(n => n.idNumero !== numero.idNumero));
    } else {
      setNumerosSeleccionados([...numerosSeleccionados, numero]);
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
    setShowModal2(true); // Ouvri modal enfòmasyon itilizatè a otomatikman
  };
  const handleCloseModal = () => setShowModal(false);
  const handleCloseModal2 = () => setShowModal2(false);

  const actualizarNumerosSeleccionados = async () => {
    const idNumeros = numerosSeleccionados.map(n => n.idNumero);
    const data = {
      idNumeros,
      nombre: name,
      telefono,
      estado: 'pendiente',
      identificacion,
      direccion,
    };
    try {
      const res = await fetch(`${baseURL}/numeroPutClient.php`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      const result = await res.json();
      if (result.mensaje) console.log(result.mensaje);
      else if (result.error) console.error(result.error);
    } catch (error) {
      console.error('Error al actualizar números:', error);
    }
  };

  const handleStripePayment = async () => {
    if (!name || !telefono || !identificacion || !direccion) {
      Swal.fire('Error!', 'Por favor, complete los campos.', 'error');
      return;
    }

    await actualizarNumerosSeleccionados();

    const numerosList = numerosSeleccionados.map(n => n.numero);

    try {
      const response = await fetch(`${baseURL}/checkout.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          numeros: numerosList,
          name,
          telefono,
          identificacion,
          direccion,
        }),
      });

      const result = await response.json();

      if (result.url) {
        window.location.href = result.url;
      } else {
        Swal.fire('Error', result.error || 'No se pudo iniciar el pago.', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      Swal.fire('Error', 'Hubo un problema al iniciar el pago.', 'error');
    }
  };

  const borrarSeleccion = () => {
    setNumerosSeleccionados([]);
    handleCloseModal2();
    handleCloseModal();
  };

  const canShowPayButton = name.trim() !== '' && telefono.trim() !== '' && identificacion.trim() !== '' && direccion.trim() !== '';

  return (
    <div className="ContentNumeros">
      {numeros.length > 0 && (
        <div className="titleSection">
          <h2>Selecciona tu número</h2>
          <FontAwesomeIcon icon={faAngleDoubleRight} className="iconTitle" />
        </div>
      )}

      {numeros.length > 0 && (
        <button
          className="generar"
          onClick={generarNumero}
          disabled={rifa?.estado === 'finalizada'}
        >
          <FontAwesomeIcon icon={faSearch} /> Luck machine
        </button>
      )}

      {loading ? (
        <div>Cargando...</div>
      ) : (
        <div className="DataGrapNumber">
          {numeros.map(item => (
            <button
              key={item.idNumero}
              className={
                numerosSeleccionados.some(n => n.idNumero === item.idNumero)
                  ? 'selectedBtn'
                  : item.estado === 'disponible'
                    ? 'activeBtn'
                    : 'descativeBtn'
              }
              disabled={rifa?.estado === 'finalizada' || item.estado !== 'disponible'}
              onClick={() => handleNumeroClick(item)}
            >
              <strong>{item.numero}</strong>
            </button>
          ))}
        </div>
      )}

      {numerosSeleccionados.length > 0 && (
        <button className="openModalBtn" onClick={handleOpenModal}>
          Go to pay ({numerosSeleccionados.length})
        </button>
      )}

      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        contentLabel="Números Seleccionados"
        className="modal-cart"
        overlayClassName="overlay-cart"
      >
        <div className="deFLex">
          <button onClick={handleCloseModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
          <button onClick={borrarSeleccion}>Limpiar números seleccionados</button>
        </div>
        <div className="modal-send-form">
          <div className="contenModal">
            {numerosSeleccionados.map(numero => (
              <button key={numero.idNumero} className="selectedBtn"><strong>{numero.numero}</strong></button>
            ))}
          </div>

          {canShowPayButton && (
            <button className="wpp" onClick={handleStripePayment}>
              Pay with Stripe <WhatsappIcon />
            </button>
          )}
        </div>

        <Modal
          isOpen={showModal2}
          onRequestClose={handleCloseModal2}
          contentLabel="Reserva tus números"
          className="modal-cart"
          overlayClassName="overlay-cart"
        >
          <div className="deFLex">
            <button onClick={handleCloseModal2}><FontAwesomeIcon icon={faArrowLeft} /></button>
            <h4>Reserva tus números</h4>
          </div>
          <div className="modal-send-form">
            <input
              type="text"
              placeholder="Name (required)"
              value={name}
              onChange={e => setName(e.target.value)}
            />
            <input
              type="tel"
              placeholder="Phone (required)"
              value={telefono}
              onChange={e => setTelefono(e.target.value)}
            />
            <input
              type="text"
              placeholder="Identification (required)"
              value={identificacion}
              onChange={e => setIdentificacion(e.target.value)}
            />
            <input
              type="text"
              placeholder="Direction (required)"
              value={direccion}
              onChange={e => setDireccion(e.target.value)}
            />
             {/* Bouton "Pay with Stripe" ap parèt otomatikman anba chan "Direction" si tout chan ranpli */}
    {name.trim() !== '' && telefono.trim() !== '' && identificacion.trim() !== '' && direccion.trim() !== '' && (
      <button className="wpp" onClick={handleStripePayment}>
        Pay with Stripe <WhatsappIcon />
      </button>
    )}
          </div>
        </Modal>
      </Modal>
    </div>
  );
}